const React = require('react');
const MenuItem = require('@material-ui/core/MenuItem').default;
const ClickAwayListener
  = require('@material-ui/core/ClickAwayListener').default;
const Grow = require('@material-ui/core/Grow').default;
const Paper = require('@material-ui/core/Paper').default;
const Popper = require('@material-ui/core/Popper').default;
const MenuList = require('@material-ui/core/MenuList').default;
const map = require('mn-utils/map');
const invoke = require('mn-utils/invoke');
const uniqIdProvider = require('mn-utils/uniqIdProvider');
const withState = require('../../../utils/withState');

const getId = uniqIdProvider('menu_');


module.exports = withState((setState) => {
  function handleClick(e) {
    setState({
      node: e.currentTarget,
    });
  }
  function handleClose(e) {
    setState({
      node: null,
    });
  }
  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      handleClose();
    }
  }

  const nodeId = getId();

  return (state, props) => {
    const {
      node,
    } = state;
    return (
      <>
        <div
          aria-controls={nodeId}
          onClick={handleClick}
        >{props.children}</div>
        <Popper
          open={!!node}
          anchorEl={node}
          transition
          className="z1000"
        >
          {({TransitionProps, placement}) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === 'bottom'
                  ? props.transformOriginTop || 'center top'
                  : props.transformOriginBottom || 'center bottom',
              }}
            >
              <Paper className="bg3E4044*2 cA3A7AC*2">
                <ClickAwayListener
                  onClickAway={handleClose}
                >
                  <MenuList
                    className="pv15*2"
                    id={nodeId}
                    onKeyDown={handleListKeyDown}
                  >
                    {map(props.items, (item, i) => {
                      return (
                        <MenuItem
                          disabled={!!item.disabled}
                          className="h38*2 ph25*2 wmin160 cF*2 dn bg02:h*2"
                          key={item.id || item.name || i}
                          onClick={(e) => {
                            handleClose();
                            invoke(item, 'onClick', [e]);
                          }}
                        >{item.name}</MenuItem>
                      );
                    }, [])}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </>
    );
  };
});
